export const sizes = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200
};

export const devices = {
  xs: `(max-width: ${sizes.xs}px)`,
  sm: `(max-width: ${sizes.sm}px)`,
  md: `(max-width: ${sizes.md}px)`,
  lg: `(max-width: ${sizes.lg}px)`
};
